const industryReducer = (state, action) => {
    switch (action.type) {
        case "TOGGLE" :
            return
        default:
            throw new Error('Commercial Reducer -- Check your action.type')
    }
}

export default industryReducer;